import './MapCMGeometrySelected.less';
import { Layer, Marker, Source } from 'react-map-gl';
import { Feature } from '../../../models/Geoserver';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import {
  addFeatureSelected,
  FeatureSelectedMode,
  selectFeatureSelected,
  selectFeatureSelectedMode,
} from '../../../store/slice/mapLayersSlice';
import Icon from '@ant-design/icons';
import { ReactComponent as Plus } from '../../../res/svg/bigger_plus.svg';
import { Button } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { getTopRightCoordinate } from '../../../utils/GeometryUtils';
import { selectCurrentTask } from '../../../store/slice/taskSlice';


function MapCMGeometrySelected() {

  const featureSelected: Feature | undefined = useAppSelector(
    selectFeatureSelected,
  );
  const mode: FeatureSelectedMode = useAppSelector(
    selectFeatureSelectedMode,
  );
  const currentTask = useAppSelector(selectCurrentTask);
  const dispatch = useAppDispatch();
  const [buttonVisible, setButtonVisible] = useState(false);

  useEffect(() => {
    if (featureSelected && !buttonVisible && currentTask?.id) {
      requestAnimationFrame(() => setButtonVisible(true));
    }
    if (!featureSelected) {
      setButtonVisible(false);
    }
  }, [buttonVisible, featureSelected]);

  let buttonCoordinate = useMemo(() => featureSelected ?
    getTopRightCoordinate(featureSelected) : [0, 0], [featureSelected]);

  if (!featureSelected || mode !== 'add') return null;


  return (
    <div>
      <Marker longitude={buttonCoordinate[0]} latitude={buttonCoordinate[1]}>
        <div
          className={
            'at-map-cm-geometry-selected__add-geometry-container ' +
            (buttonVisible ? 'selected' : '')
          }
        >
          <Button
            className={'at-map-cm-geometry-selected__add-geometry '}
            size='large'
            shape='round'
            onClick={(e) => {
              dispatch(addFeatureSelected());
              e.stopPropagation();
            }}
            type={'ghost'}
            icon={<Icon height={16} component={Plus} />}
          >Agregar a la tarea</Button>
        </div>

      </Marker>
      <Source id={'MapCMGeometrySelectedSource'}
              type='geojson' data={featureSelected as any}>

        <Layer beforeId={'order-current-line'} id={'MapCMGeometrySelectedSourceFill'} type={'fill'} paint={{
          'fill-color': '#595959',
          'fill-opacity': 1,
        }}
        />
        <Layer beforeId={'order-current-line'} id={'MapCMGeometrySelectedSourceLine'} type={'line'} paint={{
          'line-color': '#48C2C4',
          'line-width': 5,
        }}
        />

      </Source>

    </div>
  );
}

export default MapCMGeometrySelected;
